import useDelegatingLearnMore from './useDelegatingLearnMore';
import { useDispatch, useSelector } from 'react-redux';
import { modalsActions } from '../redux/slices/modals';
import { useCallback, useMemo } from 'react';

export const useLearnMore = (contentIdentifier: string, attribute?: string) => {
  const delegatingLearnMore = useDelegatingLearnMore();
  const delegateLearnMoreContent = useSelector(
    (state: any) => state.config?.actionsModule?.delegateLearnMoreContent
  );
  const configActionLoadLearnMore = useSelector(
    (state: any) => state.config?.actionsModule?.loadLearnMoreContent
  );
  const dispatch = useDispatch();

  const learnMoreVisible = useMemo(() => {
    return (
      (delegatingLearnMore && contentIdentifier) ||
      (configActionLoadLearnMore && contentIdentifier)
    );
  }, [delegatingLearnMore, configActionLoadLearnMore, contentIdentifier]);

  const delegateLearnMoreCheck = useCallback(() => {
    if (
      attribute?.toLowerCase() === 'warrantyoptions' &&
      configActionLoadLearnMore &&
      contentIdentifier
    ) {
      dispatch(modalsActions.setListLearnMoreModal([contentIdentifier]));
      dispatch(modalsActions.setOpenLearnMoreModal(contentIdentifier));
    } else if (delegateLearnMoreContent && contentIdentifier) {
      delegateLearnMoreContent(contentIdentifier);
    } else {
      configActionLoadLearnMore(contentIdentifier);
    }
  }, [
    contentIdentifier,
    configActionLoadLearnMore,
    delegateLearnMoreContent,
    attribute,
  ]);

  return { learnMoreVisible, delegateLearnMoreCheck };
};
